import { Theme } from "@mui/material/styles"; 

const categoryBusinessCardClass = (theme: Theme) => ({
  root: {
    padding: theme.spacing(1),
    marginTop: theme.spacing(1),
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(2), // Reduce padding on smaller screens
      marginTop: theme.spacing(3), 
    },
  },  
});

export default categoryBusinessCardClass;
